<template>
	<div></div>
</template>

<script>
export default {
  name: 'loanAgreement',
  data () {
    return {
      
    }
  },
}	
</script>


// WEBPACK FOOTER //
// src/contract/loanAgreement.vue